// extracted by mini-css-extract-plugin
export var cardHeader = "_gl-0";
export var reorderHandle = "_gl-3";
export var titleArea = "_gl-1";
export var titleAreaWithHandle = "_gl-2";